var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentNew = function SvgDocumentNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d5d8fd;}.b{fill:#212fcc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(141 -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(-141 13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.577V10.964a.577.577,0,0,0,.577.577H8.656a.577.577,0,0,0,.577-.577V.577A.577.577,0,0,0,8.656,0H.577A.577.577,0,0,0,0,.577ZM4.616,9.233H1.731V8.079H4.616ZM7.5,6.348H1.731V5.194H7.5Zm0-2.885H1.731V2.308H7.5Z",
    transform: "translate(-133.616 19.229)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DocumentNew.891fa913.svg";
export { ForwardRef as ReactComponent };